import { Injectable, NgZone } from '@angular/core';
import { LanguageService } from './language.service';

@Injectable({
  providedIn: 'root'
})
export class TextToSpeechService {

  private isSpeechEnabled = false;
  private voices = null;
  audio: HTMLAudioElement;

  constructor(private zone: NgZone,private languageService : LanguageService) { }

  // Toggle the speech feature on or off
  toggleSpeech() {
    this.isSpeechEnabled = !this.isSpeechEnabled;
    if (this.isSpeechEnabled) {
      const info:any = this.languageService.getTranslationSync('Text to speech feature is enabled,Hover on the content you want to Hear ! or visiting every new page i will read it for you');
      console.log(info);
      this.speak(info);
      this.loadVoices();
    } else {
      window.speechSynthesis.cancel();
    }
  }
playAudio() {
  const currentLang = this.languageService.currentLanguage;

  const audioPath = currentLang === 'mr'
    ? 'assets/ElevenLabs_2026-04-07T13_24_03_Shekhar.mp3'
    : 'assets/ElevenLabs_2026-04-07T13_19_19_Kushal.mp3';

  // If audio already exists
  if (this.audio) {
    // Resume if paused
    if (this.audio.paused) {
      this.audio.play();
    } else {
      // Pause if playing
      this.audio.pause();
    }
    return;
  }

  // First time play
  this.audio = new Audio(audioPath);

  this.audio.onended = () => {
    this.audio = null; // reset after complete
  };

  this.audio.play().catch(err => {
    console.error('Audio play failed:', err);
  });
}

// ✅ Stop completely (optional)
stopAudio() {
  if (this.audio) {
    this.audio.pause();
    this.audio.currentTime = 0;
    this.audio = null;
  }
}
  // Check if the speech feature is enabled
  isSpeechFeatureEnabled(): boolean {
    return this.isSpeechEnabled;
  }

  isEnabled(): boolean {
    return this.isSpeechEnabled;
  }

  // Speak the text
  speak(text: string) {
    if (this.isSpeechEnabled && 'speechSynthesis' in window) {
      const speech = new SpeechSynthesisUtterance(text);

      // Optional: Set language, pitch, and rate
      if(this.languageService.currentLanguage == 'mr'){
        // speech.lang = 'mr-IN'; // Language code
        speech.lang = 'hi-IN'; // Language code
      }else{
        speech.lang = 'en-US'; // Language code
      }

      speech.pitch = 1; // Range: 0 to 2
      speech.rate = 1; // Range: 0.1 to 10

      // Run within Angular zone
      this.zone.run(() => {
        // console.log('Speaking: ', text);
        window.speechSynthesis.cancel();
        window.speechSynthesis.speak(speech);
      });
    } else if (!('speechSynthesis' in window)) {
      console.error('SpeechSynthesis API is not supported in this browser.');
    }
  }

  // Load available voices and languages
  private loadVoices() {
    if ('speechSynthesis' in window) {
      const synth = window.speechSynthesis;
      const loadVoices = () => {
        this.voices = synth.getVoices();
        if (!this.voices.length) {
          synth.onvoiceschanged = () => {
            this.voices = synth.getVoices();
          };
        }
      };

      loadVoices();
    } else {
      console.error('SpeechSynthesis API not supported in this browser.');
    }
  }
  
}
